"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importStar(require("react"));
const RadixCheckbox = __importStar(require("@radix-ui/react-checkbox"));
const uuid_1 = require("uuid");
const Text_1 = require("../../../components/Text/Text");
const Icon_1 = require("../Icon");
const Checkbox_styles_1 = require("./Checkbox.styles");
const CheckboxRoot = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { appearance = "solid", children } = _a, props = __rest(_a, ["appearance", "children"]);
    return (react_1.default.createElement(Checkbox_styles_1.StyledCheckboxRoot, Object.assign({ ref: forwardedRef, "$appearance": appearance }, props), children));
});
const CheckboxIndicator = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var props = __rest(_a, []);
    // I wish I could use React 18 useId() here
    const uniqueId = react_1.default.useRef((0, uuid_1.v4)());
    return (react_1.default.createElement(Checkbox_styles_1.StyledCheckboxIndicator, Object.assign({ ref: forwardedRef }, props),
        react_1.default.createElement(Checkbox_styles_1.StyledIndicatorBackground, { viewBox: "0 0 25 25", width: "25px", height: "25px", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("defs", null,
                react_1.default.createElement("clipPath", { id: uniqueId.current },
                    react_1.default.createElement("rect", { x: "4.5", y: "4.5", width: "16", height: "16", rx: "2" }))),
            react_1.default.createElement(Checkbox_styles_1.StyledIndicatorFocusRing, { x: "1.5", y: "1.5", width: "22", height: "22", rx: "5", fill: "none" }),
            react_1.default.createElement(Checkbox_styles_1.StyledIndicatorOuterRing, { x: "4.5", y: "4.5", width: "16", height: "16", rx: "2", fill: "none", clipPath: `url(#${uniqueId.current})` })),
        react_1.default.createElement(RadixCheckbox.Indicator, null,
            react_1.default.createElement(Icon_1.Icon, { size: "xsmall", name: "Tick", color: "white", className: "checkbox-icon" }))));
});
const CheckboxLabel = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Text_1.Text, { as: "label", props: Object.assign({ ref: forwardedRef }, props), skinny: true }, children));
});
CheckboxRoot.displayName = "Checkbox";
CheckboxLabel.displayName = "Checkbox.Label";
CheckboxIndicator.displayName = "Checkbox.Indicator";
exports.Checkbox = Object.assign(CheckboxRoot, {
    Label: CheckboxLabel,
    Indicator: CheckboxIndicator,
});
//# sourceMappingURL=Checkbox.js.map